import {
  CreateBibliographySearchAuthorityListRequest,
  CreateBibliographySearchAuthorityListRequestToJSON,
  CreateBibliographySearchContentListRequest,
  CreateBibliographySearchContentListRequestToJSON,
  CreateBibliographySearchListRequest,
  CreateBibliographySearchListRequestToJSON,
  CreateInspectionListRequest,
  CreateInspectionListRequestToJSON,
  CreateInterLibraryLoanBorrowListRequest,
  CreateInterLibraryLoanBorrowListRequestToJSON,
  CreateInterLibraryLoanLendListRequest,
  CreateInterLibraryLoanLendListRequestToJSON,
  CreateInterLibraryLoanRecordRequest,
  CreateInterLibraryLoanRecordRequestToJSON,
  CreateShelfTypeTempChangeRequest,
  CreateShelfTypeTempChangeRequestToJSON,
  CreateShelfTypeTempChangeFixRequest,
  HTTPBody,
  HTTPQuery,
  Job,
  JobFromJSON,
  JobSearchRequest,
  JobSearchRequestToJSON,
  CreateReferenceListRequest,
  CreateReferenceListRequestToJSON,
  CreateOrderListBibliographyListRequestToJSON,
  CreateOrderListBibliographyListRequest,
  CreateShelfTypeTempChangeFixRequestToJSON,
  CreateMagazineBookNumberListRequest,
  CreateMagazineBookNumberListRequestToJSON,
  CreateCollectionListDetailListRequestToJSON,
  CreateBrowseInsideRequest,
  CreateBrowseInsideRequestToJSON,
  CreateBulkUpdateCollectionListRequest,
  CreateBulkUpdateCollectionListRequestToJSON,
  CreateBibliographySearchDetailListRequest,
  CreateBibliographySearchDetailListRequestToJSON,
  CreateCollectionListDetailListRequest,
  CreateSchoolStatisticsAdvancementListRequestToJSON,
  CreateSchoolStatisticsAdvancementListRequest
} from '@/api'
import * as runtime from '../runtime'

export interface CreateUsersListRequest {
  ids: string[]
}

export interface CreateSystemCodeListRequest {
  codeKey: string
}

export class JobApi extends runtime.BaseAPI {
  async getAllByIds(ids: number[]): Promise<Job[]> {
    const queryParameters: runtime.HTTPQuery = { ids }

    const response = await this.requestGet(`/jobs/search`, queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(JobFromJSON)
    ).value()
  }

  async getAllBy(request: JobSearchRequest): Promise<Job[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(JobSearchRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(`/jobs/search`, queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(JobFromJSON)
    ).value()
  }

  async createUserList(request: CreateUsersListRequest): Promise<number> {
    const response = await this.requestPost(`/jobs/user-list`, request)

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createSystemCodeList(
    request: CreateSystemCodeListRequest
  ): Promise<number> {
    const bodyParameters: runtime.HTTPBody = {}

    if (request.codeKey) {
      bodyParameters.code_key = request.codeKey
    }

    const response = await this.requestPost(
      `/jobs/system-code-list`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createSystemCodeAddressList(): Promise<number> {
    const response = await this.requestPost('/jobs/system-code-address-list')

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createSystemCodeAreaList(): Promise<number> {
    const response = await this.requestPost('/jobs/system-code-area-list')

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createInterLibraryLoanLendList(
    request: CreateInterLibraryLoanLendListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateInterLibraryLoanLendListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/interlibrary-loan/lend-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createInterLibraryLoanRecord(
    request: CreateInterLibraryLoanRecordRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateInterLibraryLoanRecordRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/interlibrary-loan-record',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createInterLibraryLoanBorrowList(
    request: CreateInterLibraryLoanBorrowListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateInterLibraryLoanBorrowListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/interlibrary-loan/borrow-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createInspectionList(
    request: CreateInspectionListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateInspectionListRequestToJSON(request)
    const response = await this.requestPost(
      '/jobs/inspection-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createBibliographySearchList(
    request: CreateBibliographySearchListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateBibliographySearchListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/bibliography-search-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createBibliographySearchDetailList(
    request: CreateBibliographySearchDetailListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateBibliographySearchDetailListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/bibliography-search-detail-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createBibliographySearchAuthorityList(
    request: CreateBibliographySearchAuthorityListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateBibliographySearchAuthorityListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/bibliography-search-authority-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createBibliographySearchContentList(
    request: CreateBibliographySearchContentListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateBibliographySearchContentListRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/jobs/bibliography-search-content-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createShelfTypeTempChange(
    request: CreateShelfTypeTempChangeRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateShelfTypeTempChangeRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/shelf-type-temp-change',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createShelfTypeTempChangeFix(
    request: CreateShelfTypeTempChangeFixRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateShelfTypeTempChangeFixRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/jobs/shelf-type-temp-change-fix',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createReferenceList(
    request: CreateReferenceListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateReferenceListRequestToJSON(request)
    const response = await this.requestPost(
      '/jobs/reference-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createOrderListBibliographyList(
    request: CreateOrderListBibliographyListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateOrderListBibliographyListRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/jobs/order-list/bibliography-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createMagazineBookNumberList(
    request: CreateMagazineBookNumberListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateMagazineBookNumberListRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/jobs/magazine-book-number-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createCollectionListDetailList(
    request: CreateCollectionListDetailListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateCollectionListDetailListRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/jobs/collection-list-detail-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createBrowseInside(
    request: CreateBrowseInsideRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateBrowseInsideRequestToJSON(request)

    const response = await this.requestPost(
      '/jobs/browse-inside',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createBulkUpdateCollectionLIst(
    request: CreateBulkUpdateCollectionListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateBulkUpdateCollectionListRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/jobs/bulk-update-collection-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async createSchoolStatisticsAdvancementList(
    request: CreateSchoolStatisticsAdvancementListRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = CreateSchoolStatisticsAdvancementListRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/jobs/school-statistics-advancement-list',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
